import { React, useState, useEffect } from "react";
import Stages from "./Stages";
import { fetchBusinessList } from "../services/apiService";

const Footer = () => {

  const [companyId, setCompanyId] = useState("");

  const loadData = async () => {
    try {
      const result = await fetchBusinessList("api/v1/list");
      if (result.success) {
        if (result.data.length == 1) {
          setCompanyId(result.data[0].id);
        }
      }
    } catch (error) {
      
    }
  };

  useEffect(() => {
    loadData();
  }, []);

    return (
      <div className="container fixed-bottom" style={{ background: "#fff" }}>
        <Stages companyId={companyId} />
        <div className="bg-primary">
          <div className="text-center p-2">
            <span className="text-white">© 2025 Casual Tech</span>
          </div>
        </div>
      </div>
    );
}

export default Footer;